module.exports = __webpack_public_path__ + "6c2279728b33e5e778de81a7b4c442bd.glb";